import {
  ConfigApi,
  createApiRef,
  DiscoveryApi,
  FetchApi,
} from '@backstage/core-plugin-api';

type Options = {
  discoveryApi: DiscoveryApi;
  configApi: ConfigApi;
  fetchApi: FetchApi;
};

export const prometheusApiRef = createApiRef<PrometheusAPI>({
  id: 'plugin.prometheus.service',
});


export interface QueryRangeResult {
  metric: {
    [key: string]: string;
  };
  values: [number, string][];
}


// create base response interface with dynamic data type
export interface BaseResponse<T> {
  status: string;
  data: {
    resultType: string;
    result: T[];
  };
  stats: {
    seriesFetched: string;
    executionTimeMsec: number;
  };
}



export class PrometheusAPI {
  private readonly backendUrl: string | undefined;
  private readonly fetchApi: FetchApi;
  private readonly confApi: ConfigApi;

  constructor(options: Options) {
    this.backendUrl = options.configApi.getOptionalString('backend.baseUrl');
    this.confApi = options.configApi;
    this.fetchApi = options.fetchApi;
  }

  private async getUrls() {
    return {
      apiUrl: `${this.backendUrl}/api/prometheus/proxy`,
    };
  }


  getPrometheusUrl(): string {
    return (
      this.confApi.getOptionalString('integrations.prometheus.host') ||
      'https://vm.dev.sev-2.coom'
    );
  }

  async getQueryRange(data: any): Promise<BaseResponse<QueryRangeResult>> {
    const { apiUrl } = await this.getUrls();

    const request = await this.fetchApi.fetch(
      `${apiUrl}/query_range`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      },
    );

    if (!request.ok) {
      throw new Error(
        `failed to fetch data, status ${request.status}: ${request.statusText}`,
      );
    }
    return request.json();
  }
}